// src/components/QRPdfDocument.jsx
import React from 'react';
import { Document, Page, Text, View, Font, StyleSheet, Image } from '@react-pdf/renderer';

// 長さ制限してカットする関数
function truncateByVisualLength(str, maxLength) {
  let len = 0;
  let result = '';

  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    const charLength = (code <= 0x7f) ? 0.5 : 1;

    if (len + charLength > maxLength) {
      break;
    }

    len += charLength;
    result += str[i];
  }

  return result;
}


// フォント登録
Font.register({
  family: 'Impact',
  src: '/fonts/impact.ttf',
});
Font.register({
  family: 'Meiryo',
  src: '/fonts/meiryo.ttf',
});
Font.register({
  family: 'Meiryo',
  src: '/fonts/Meiryo-Bold.ttf',
  fontWeight: 'bold',
});
Font.register({
  family: 'Segoe',
  src: '/fonts/segoe-ui.ttf',
});
Font.register({
  family: 'Segoe',
  src: '/fonts/segoe-ui-bold.ttf',
  fontWeight: 'bold',
});

const LABEL_WIDTH = 170.8; // 62mm 余白の関係で170で作る175
const LABEL_HEIGHT = 65.1; // 29mm 余白の関係で65で作る82

const LARGE_QR_LABEL_WIDTH = 170.8;
const LARGE_QR_LABEL_HEIGHT = 170.8;

const styles = StyleSheet.create({
  page: {
    width: LABEL_WIDTH,
    height: LABEL_HEIGHT,
    backgroundColor: '#ffffff',
    position: 'relative',
  },
  container: {
    width: LABEL_WIDTH,
    height: LABEL_HEIGHT,
    position: 'relative',
  },
  conditionEn: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 125,
    height: 10,
    backgroundColor: 'black',
    color: 'white',
    fontSize: 8,
    fontFamily: 'Segoe',
    fontWeight: 'bold',
    lineHeight: 1,
    paddingTop: 0,
    paddingLeft: 1.1,
  },
  conditionJp: {
    position: 'absolute',
    top: 10,
    left: 0,
    width: 56,
    height: 5,
    fontSize: 5,
    fontFamily: 'Meiryo',
    fontWeight: 'bold',
    color: 'black',
    lineHeight: 1,
  },
  boxDamage: {
    position: 'absolute',
    top: 15,
    left: 0,
    width: 56,
    height: 8,
    fontSize: 5,
    fontFamily: 'Meiryo',
    fontWeight: 'bold',
    borderBottom: '1pt solid black',
    color: 'black',
    lineHeight: 1,
  },
  comment1: {
    position: 'absolute',
    top: 10,
    left: 56,
    width: 69,
    height: 5,
    fontSize: 5,
    fontFamily: 'Meiryo',
    fontWeight: 'bold',
    paddingLeft: 2,
    color: 'black',
    lineHeight: 1,
  },
  comment2: {
    position: 'absolute',
    top: 15,
    left: 56,
    width: 69,
    height: 8,
    fontSize: 5,
    fontFamily: 'Meiryo',
    fontWeight: 'bold',
    paddingLeft: 2,
    borderBottom: '1pt solid black',
    color: 'black',
    lineHeight: 1,
  },
  spPriceEn: {
    position: 'absolute',
    top: 24,
    left: 0,
    width: 30,
    height: 8,
    fontSize: 8,
    fontFamily: 'Impact',
    color: 'white',
    backgroundColor: 'black',
    textAlign: 'center',
    lineHeight: 1,
  },
    spPriceEn2: {
    position: 'absolute',
    top: 32,
    left: 0,
    width: 30,
    height: 8,
    fontSize: 8,
    fontFamily: 'Impact',
    color: 'white',
    backgroundColor: 'black',
    textAlign: 'center',
    lineHeight: 1,
  },
  spPriceJp: {
    position: 'absolute',
    top: 40,
    left: 0,
    width: 30,
    height: 7,
    fontSize: 7,
    fontWeight:'bold',
    fontFamily: 'Meiryo',
    color: 'black',
    textAlign: 'center',
    lineHeight: 1,
  },
  priceMain: {
    position: 'absolute',
    top: 19,
    left: 32,
    width: 95,
    height: 27,
    fontSize: 27,
    fontFamily: 'Impact',
    color: 'black',
    textAlign: 'right',
    paddingRight: 2,
    lineHeight: 1,
  },
  priceMainBig: {
    position: 'absolute',
    top: 19,
    left: 22,
    width: 95,
    height: 27,
    fontSize: 27,
    fontFamily: 'Impact',
    color: 'black',
    textAlign: 'right',
    paddingRight: 2,
    lineHeight: 1,
  },
  priceWithTax: {
    position: 'absolute',
    top: 47,
    left: 0,
    width: 92,
    height: 10,
    fontSize: 10,
    fontFamily: 'Impact',
    fontWeight:'bold',
    color: 'black',
    textAlign: 'right',
    lineHeight: 1,
    borderTop: '1pt solid black',
  },
    priceWithTaxJ: {
    position: 'absolute',
    top: 47,
    left: 92,
    width: 33,
    height: 10,
    fontSize: 9,
    fontFamily: 'Meiryo',
    fontWeight:'bold',
    color: 'black',
    textAlign: 'right',
    lineHeight: 1,
    borderTop: '1pt solid black',
    paddingRight: 4,
  },
  qrArea: {
    position: 'absolute',
    top: 31,
    left: 132,
    width: 34,
    height: 34,
  },
  qrImage: {
    width: 34,
    height: 34,
  },
  janCode: {
    position: 'absolute',
    top: 0,
    left: 132,
    width: 10,
    height: 65,
    fontSize: 5,
    fontFamily: 'Meiryo',
    fontWeight: 'bold',
    color: 'black',
    textAlign: 'center',
    transform: 'rotate(90deg)',
    transformOrigin: 'top left',
    paddingLeft: 2,
    lineHeight: 1,
  },
  conditionR: {
    position: 'absolute',
    top: 0,
    left: 132,
    width: 38,
    height: 12,
    backgroundColor: 'black',
    color: 'white',
    fontSize: 5,
    fontFamily: 'Meiryo',
    fontWeight:'bold',
    textAlign: 'center',
    lineHeight: 1,
  },
  priceR: {
    position: 'absolute',
    top: 12,
    left: 132,
    width: 38,
    height: 10,
    fontSize: 10,
    lineHeight: 1,
    fontFamily: 'Segoe',
    fontWeight: 'bold',
    color: 'black',
    textAlign: 'right',
    paddingRight: 2,
  },
  priceRBig: {
    position: 'absolute',
    top: 12,
    left: 132,
    width: 38,
    height: 10,
    fontSize: 9,
    lineHeight: 1,
    fontFamily: 'Segoe',
    fontWeight: 'bold',
    color: 'black',
    textAlign: 'right',
    paddingRight: 2,
  },
  taxR: {
    position: 'absolute',
    top: 22,
    left: 132,
    width: 38,
    height: 7,
    fontSize: 7,
    fontFamily: 'Segoe',
    fontWeight: 'bold',
    color: 'black',
    textAlign: 'right',
    paddingRight: 2,
    lineHeight: 1,
  },
  itemName: {
    position: 'absolute',
    top: 57,
    left: 0,
    width: 125,
    height: 8,
    fontSize: 5,
    fontFamily: 'Meiryo',
    fontWeight: 'bold',
    textAlign: 'center',
    color: 'black',
    lineHeight: 1,
  },

  largeQrPage: {
    width: LARGE_QR_LABEL_WIDTH,
    height: LARGE_QR_LABEL_HEIGHT,
    backgroundColor: '#ffffff',
    position: 'relative',
  },
  largeQrContainer: {
    width: LARGE_QR_LABEL_WIDTH,
    height: LARGE_QR_LABEL_HEIGHT,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  largeQrImage: {
    width: 170,
    height: 170,
  },
});

const QRPdfDocument = ({ barcodeItems, largeQrOnly = false }) => (
  <Document>
    {barcodeItems.map((item) =>
      Array.from({ length: largeQrOnly ? 1 : item.number }).map((_, copyIdx) => (
        <Page
          key={`${item.id}-${largeQrOnly ? "large" : copyIdx}`}
          size={{
            width: largeQrOnly ? LARGE_QR_LABEL_WIDTH : LABEL_WIDTH,
            height: largeQrOnly ? LARGE_QR_LABEL_HEIGHT : LABEL_HEIGHT,
          }}
          style={largeQrOnly ? styles.largeQrPage : styles.page}
        >
          {largeQrOnly ? (
            <View style={styles.largeQrContainer}>
              <Image src={item.qrImage} style={styles.largeQrImage} />
            </View>
          ) : (
            <View style={styles.container}>
              <Text style={styles.conditionEn}>{item.condition_id?.condition_eng || ''}</Text>
              <Text style={styles.conditionJp}>{item.condition_id?.condition_jpn || ''}</Text>
              <Text style={styles.boxDamage}>{item.box_condition ? 'BoxDamage' : ''}</Text>
              <Text style={styles.comment1}>{item.comment1 || ''}</Text>
              <Text style={styles.comment2}>{item.comment2 || ''}</Text>

              {item.price_sp ? (
                <>
                  <Text style={styles.spPriceEn}>Special</Text>
                  <Text style={styles.spPriceEn2}>Price</Text>
                </>
              ) : null}

              <Text style={styles.spPriceJp}>{item.price_sp ? '特価商品' : ''}</Text>

              <Text style={item.price != null && item.price >= 100000 ? styles.priceMainBig : styles.priceMain}>
                {item.price != null ? `¥${item.price.toLocaleString()}` : ''}
              </Text>

              <Text style={styles.priceWithTax}>
                {item.price != null ? `¥${Math.round(item.price * 1.1).toLocaleString()} [TAX.inc]` : ''}
              </Text>

              <Text style={styles.priceWithTaxJ}>
                {item.price != null ? `[税込]` : ''}
              </Text>

              <View style={styles.qrArea}>
                <Image src={item.qrImage} style={styles.qrImage} />
              </View>

              <Text style={styles.janCode}>{item.label_item_id?.jan || ''}</Text>
              <Text style={styles.conditionR}>{item.condition_id?.condition_eng || ''}</Text>

              <Text style={item.price != null && item.price >= 100000 ? styles.priceRBig : styles.priceR}>
                {item.price != null ? `¥${item.price.toLocaleString()}` : ''}
              </Text>

              <Text style={styles.taxR}>+PlusTAX</Text>
              <Text style={styles.itemName}>
                {truncateByVisualLength(item.label_item_id?.item_name || '', 24)}
              </Text>
            </View>
          )}
        </Page>
      ))
    )}
  </Document>
);

export default QRPdfDocument;
